<!-- Contact form modal overlay -->
<div class="modal-backdrop">
  <div class="modal-panel">

    <!-- Header -->
    <div class="modal-header">
      <h2>{{ 'contactModal.title' | t }}</h2>
      <button
        class="modal-close-btn"
        type="button"
        (click)="onClose()"
        [attr.aria-label]="'modalCommon.closeAria' | t">
        &times;
      </button>
    </div>

    <!-- Body -->
    <div class="modal-body">
      <p class="modal-intro">
        {{ 'contactModal.intro' | t }}
      </p>

      @if (showDevHelper) {
        <div class="dev-helper-box" role="note">
          <div class="dev-helper-head">{{ 'modalCommon.devDataTitle' | t }}</div>
          <div class="dev-helper-body">{{ 'contactModal.devBody' | t }}</div>
          <button type="button" class="btn-dev-fill" (click)="insertTestData()">
            {{ 'modalCommon.insertTestData' | t }}
          </button>
        </div>
      }

      <form class="contact-form" novalidate (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label for="contact-email">
            {{ 'modalCommon.email' | t }}
            <span aria-hidden="true">*</span>
          </label>
          <input
            id="contact-email"
            type="email"
            placeholder="beispiel@email.de"
            [ngModel]="email()"
            (ngModelChange)="email.set($event)"
            name="email"
            required
            autocomplete="email" />
          @if (submitAttempted() && !emailValid()) {
            <span class="field-error">{{ 'modalCommon.emailError' | t }}</span>
          }
        </div>

        <div class="form-group">
          <label for="contact-telefon">
            {{ 'contactModal.phone' | t }}
            @if (phoneRequired()) {
              <span aria-hidden="true">*</span>
            }
          </label>
          <input
            id="contact-telefon"
            type="tel"
            placeholder="+49 123 4567890"
            [ngModel]="telefon()"
            (ngModelChange)="telefon.set($event)"
            name="telefon"
            [required]="phoneRequired()"
            autocomplete="tel" />
          @if (submitAttempted() && !telefonValid()) {
            <span class="field-error">{{ 'modalCommon.phoneError' | t }}</span>
          }
        </div>

        <div class="form-group">
          <label for="contact-callback-toggle">{{ 'contactModal.callbackTime' | t }}</label>
          <button
            id="contact-callback-toggle"
            class="callback-availability__trigger"
            type="button"
            aria-controls="contact-callback-options"
            [attr.aria-expanded]="callbackExpanded()"
            (click)="toggleCallbackExpanded()">
            <span class="callback-availability__summary">
              @if (callbackTimeSlot()) {
                {{ callbackTimeSlotLabel() }}
              } @else {
                {{ 'contactModal.noSelection' | t }}
              }
            </span>
            <span class="callback-availability__chevron" aria-hidden="true">v</span>
          </button>

          @if (callbackExpanded()) {
            <div id="contact-callback-options" class="callback-availability__panel" role="group" [attr.aria-label]="'contactModal.callbackTime' | t">
              <div class="callback-availability__head" aria-hidden="true">
                <span></span>
                @for (period of callbackPeriods; track period) {
                  <span>{{ callbackPeriodLabel(period) }}</span>
                }
              </div>

              @for (day of callbackWeekdays; track day.key) {
                <div class="callback-availability__row">
                  <span class="callback-availability__day">{{ callbackDayLabel(day.key) }}</span>
                  @for (period of callbackPeriods; track period) {
                    <label class="callback-availability__slot">
                      <input
                        type="checkbox"
                        [name]="'callback_time_slot_' + day.key + '_' + period"
                        [checked]="isCallbackSlotSelected(day.key, period)"
                        (change)="onCallbackSlotChange(day.key, period, $event)" />
                      <span class="callback-availability__check-label">{{ callbackPeriodLabel(period) }}</span>
                    </label>
                  }
                </div>
              }
            </div>
          }
        </div>
      </form>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button
        type="button"
        class="btn-cancel"
        (click)="onClose()">
        {{ 'common.cancel' | t }}
      </button>
      <button
        type="button"
        class="btn-submit"
        (click)="onSubmit()">
        {{ 'common.submit' | t }}
      </button>
    </div>

  </div>
</div>
